module.exports = "<div class=\"col-xs-2 text-center\"><input type=\"checkbox\" name=\"priority\" {% if enabled %} checked {% endif %}></div>";
